import React, { useState, useEffect } from "react";
import { Trans } from "react-i18next";
import { formatCurrency } from "services/util";
import { withDocumentRenderer } from "components";
import PaySlipDocument from "components/documents/PaySlip";
import { Table, Button, Card, CardBody } from "reactstrap";


const DownloadPayslip = withDocumentRenderer({
    onDownload:
        ({ selectedOrganisation, client }) =>
            (getDocument) => {
                getDocument(
                    {
                        client,
                        selectedOrganisation,
                    },
                    `pay_slip.pdf`
                );
            },
})(({ DownloadDocument, DocumentRenderer, payslip }) => {
    return (
        <>
            <DownloadDocument className="mr-2" />
            <DocumentRenderer component={PaySlipDocument} item={payslip} />
        </>
    );
});

const EmployeePaySlips = ({ employee, client, limit = false }) => {
    const [payslips, setPayslips] = useState();
    const [viewAllSlips, setAllSlips] = useState();

    useEffect(
        () =>
            void (async () => {
                const payslips = await client
                    .get(`employees/${employee.id}/pay_slips`)
                    .get("data");

                let payslips_list = payslips.filter((el) => (el.pay_run__status == "Paid"))
                const last = payslips.length > 0 ? [payslips[0]] : [];

                setPayslips({
                    last,
                    all: payslips_list,
                });
            })(),
        [employee]
    );

    if (!payslips) return null;

    return (
        <div>
            <Card className="shadow-sm border">
                <CardBody>
                    <div className="row mb-3">
                        <div className="col-6">
                            <h5 className="d-print-none">
                                <Trans>Wage slips</Trans>
                            </h5>
                        </div>
                        <div className="col-6 text-right">
                        </div>
                    </div>
                    <div className="row">
                        <Button className="p-1 mb-2 btn btn-secondary d-print-none" onClick={() => setAllSlips(!viewAllSlips)} >
                            <Trans>View {viewAllSlips ? "Last" : "All"} Pay Slips</Trans>
                        </Button>
                        <Table className="mt-4 table-striped" size="sm">
                            <thead>
                                <tr>
                                    <th>
                                        <Trans>Period</Trans>
                                    </th>
                                    <th>
                                        <Trans>Gross</Trans>
                                    </th>
                                    <th>
                                        <Trans>Reimbursements</Trans>
                                    </th>
                                    <th>
                                        <Trans>Allowances</Trans>
                                    </th>
                                    <th>
                                        <Trans>Deductions</Trans>
                                    </th>
                                    <th>
                                        <Trans>Tax</Trans>
                                    </th>
                                    <th>
                                        <Trans>Net</Trans>
                                    </th>
                                    <th>
                                        <Trans>Actions</Trans>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {payslips[viewAllSlips ? "all" : "last"].slice(0, limit || payslips[viewAllSlips ? "all" : "last"].length).map((i) => (
                                    <tr key={i.id}>
                                        <td>
                                            {i.pay_run__start_date} {i.pay_run__end_date}
                                        </td>
                                        <td>{formatCurrency(i.total_earnings)}</td>
                                        <td>{formatCurrency(i.total_reimbursements)}</td>
                                        <td>{formatCurrency(i.total_allowances)}</td>
                                        <td>{`(${formatCurrency(i.total_deductions)})`}</td>
                                        <td>{formatCurrency(i.total_tax)}</td>
                                        <td>{formatCurrency(i.net_pay)}</td>
                                        <td>
                                            <DownloadPayslip
                                                selectedOrganisation={{
                                                    id: employee.connected_organisation_id,
                                                }}
                                                payslip={i}
                                                client={client}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </CardBody>
            </Card>




        </div>
    );
};

export default EmployeePaySlips